import React from 'react';
import { BsGeo } from '@react-icons/all-files/bs/BsGeo';

import { decorateComponent } from '../../../documentComponents';
import { AnchorTarget } from './AnchorTarget';
import { AnchorTargetInspector } from './AnchorTarget.Inspector';

export default decorateComponent(AnchorTarget, 'block', {
  id: 'anchorTarget',
  label: '앵커 타겟',
  defaultProps: {},
  allowedChildren: [],
  disallowedAncestors: [
    'a',
    'coupon',
    'tab',
    'carousel',
    'accordion',
  ],
  renderIcon: () => <BsGeo />,
  renderTitle: ({ targetId }) => `앵커 타겟 #${targetId ?? ''}`,
  renderInspector: AnchorTargetInspector,
});
